<template>
  <div :class="getClasses" :style="containerStyles || {}">
    <label v-if="label">{{ label }}</label>
    <input
      :type="fieldType"
      :name="name"
      :value="value"
      @input="updateField"
      :class="{disabled: isDisabled}"
      :disabled="isDisabled"
      v-if="['text', 'number', 'date'].includes(fieldType)"
    />
    <textarea
      :name="name"
      :value="value"
      @input="updateField"
      :disabled="isDisabled"
      v-if="['textarea'].includes(fieldType)"
    />
    <span v-if="errorMessage" class="field-error">
      {{ errorMessage }}
    </span>
  </div>
</template>

<script>
export default {
  name: "FormField",
  props: ["values", "name", "onUpdate", "type", "label", "addClass", "errors", "disabled", "containerStyles"],
  computed: {
    value() {
      return (this.values && this.values[this.name]) || "";
    },
    fieldType() {
      return this.type || "text";
    },
    isDisabled(){
        return this.disabled || false
    },
    getClasses() {
      let classes = {};
      if (this.addClass) classes[this.addClass] = true;
      if (this.errors && this.errors[this.name]) classes["hasError"] = true;
      return classes;
    },
    errorMessage() {
      return this.errors && this.errors[this.name];
    }
  },
  methods: {
    updateField(e) {
      this.onUpdate && this.onUpdate(e);
    }
  }
};
</script>
